// Used as vuex store module path
const MODULE_ID = 'fahrplan';
export default MODULE_ID;
